import { render, staticRenderFns } from "./terms_&_conditions.vue?vue&type=template&id=c70d4350"
import script from "./terms_&_conditions.vue?vue&type=script&lang=js"
export * from "./terms_&_conditions.vue?vue&type=script&lang=js"
import style0 from "./terms_&_conditions.vue?vue&type=style&index=0&id=c70d4350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports